import { Blogs } from "../../../../../components/backgrounds/Blogs";

export function MejorarPuntajePage() {
  return (
    <>
      <Blogs
        title={"¿Cómo mejorar mi puntaje en Datacrédito?"}
        content={
          <>
            <div className="pt-6 opacity-60 text-xl">
              <p className="">
                Necesitas aumentar tu puntaje de crédito, pero no sabes qué
                puedes hacer, tranquilo astronauta, en Galilea te contamos cómo.
              </p>
            </div>
            <div className="pt-10 pb-10 opacity-60 text-xl">
              <p className="">
                Recuerda que tu puntaje de crédito siempre tendrá un papel
                fundamental para que cualquier entidad financiera apruebe o
                rechace un crédito. Este puntaje ayuda a las entidades a
                determinar el nivel de probabilidad de que lograrás cumplir con
                una obligación a tiempo, por eso es tan importante que cuides de
                ella. Cuanto más alto sea tu puntaje, más fácil te será la
                aprobación de nuevos préstamos o líneas de crédito.
              </p>
            </div>
            <span className="text-xl lg:text-2xl font-light">
              <a href="/requisitos" className="text-purple hover:underline">
                Si quieres conocer cuales son los requisitos para solicitar tu
                crédito en Galilea da clic aquí.
              </a>
            </span>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Pero, ¿cómo se mide este puntaje?
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                La gran mayoría de las entidades utilizamos el puntaje de
                crédito y esté está determinado por los siguientes factores:
              </p>
              <ul className="pl-6 pt-6 list-disc">
                <li>Historial de pagos.</li>
                <li>Uso de crédito.</li>
                <li>Antigüedad de las cuentas bancarias.</li>
                <li>Nuevas consultas de crédito.</li>
              </ul>
              <p className="pt-10">
                Para aumentar el puntaje de crédito en centrales de riesgo como
                Datacrédito y Cifin, estas bases de datos tendrán en cuenta el
                número de cuotas históricas que hayas pagado, junto con los
                créditos que has cancelado a tiempo y tu capacidad de
                endeudamiento. Cuando hablamos de capacidad de endeudamiento,
                nos referimos a que el valor de tus cuotas mensuales nunca
                superen el 30% de tus ingresos.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">El secreto...</span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Un secreto que tenemos en nuestro mundo Galilea para aumentar
                rápidamente el ‘score’ o puntaje de crédito, es manteniendo
                créditos con nosotros de manera constante y pagar un día antes
                del día de vencimiento, este comportamiento de pago comunica a
                las entidades financieras que eres responsable de tus
                obligaciones y que estás pendiente de ellas.
              </p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Te recomendamos que sigas estas recomendaciones astronauta, así
                estarás demostrando responsabilidad a la hora de manejar tus
                finanzas y lo más seguro es que tú puntaje poco a poco aumente.
              </p>
            </div>
          </>
        }
        enlace1={
          <a href="/blog/como-aumentar-mi-cupo-de-credito" className="text-purple hover:underline">¿Cómo aumentar mi cupo de crédito en Galilea?</a>
        }
        enlace2={
          <a href="/blog/6-consejos-para-manejar-tus-finanzas" className="text-purple hover:underline">6 consejos para manejar tus finanzas personales</a>
        }
        enlace3={
          <a href="/blog/4-apps-para-llevar-un-registro-financiero" className="text-purple hover:underline">Apps para controlar tus finanzas personales</a>
        }
      />
    </>
  );
}